import { ServiceContainerComponent } from "@/routes/processes/[processId]/qpm/calculations/[calculationId]/_components/service-cost-component";
import { CalculationServiceType } from "@/services/backend/qpm/calculations/types/calculation-enum";
import { useCalculationData } from "@/services/backend/qpm/calculations/hooks/calculation-context";

export function InstallationRoute() {
  const { calculation } = useCalculationData();

  return (
    calculation && (
      <div className="mb-12 overflow-clip rounded-lg border shadow-sm">
        <ServiceContainerComponent
          calculationId={calculation.id}
          calculationServiceType={CalculationServiceType.Installation}
          serviceContainer={calculation.installationService}
        />
      </div>
    )
  );
}
